// extracted by mini-css-extract-plugin
export default {"label":"styles_label__b4GZx","requiredLabel":"styles_requiredLabel__6F7CO","flex":"styles_flex__7I060"};